export default __webpack_public_path__ + "static/media/HeadPhones.c2550a9d.png";